export const selectSaleOrderBalance = state => state.payments.saleOrderBalance
export const selectSaleOrderBalanceCurrentUser = state =>
  state.payments.saleOrderBalanceCurrentUser

export const selectBIPaymentsHistory = state => state.payments.biPaymentsHistory
export const selectBIPaymentsHistoryCurrentUser = state =>
  state.payments.biPaymentsHistoryCurrentUser
